import type { CSSProperties } from 'react';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const Checkbox = ({ checked, onChange, disabled = false }: CheckboxProps) => {
  const checkboxContainerStyle: CSSProperties = {
    width: '18px',
    height: '18px',
    border: `1px solid ${checked ? '#000000' : '#757575'}`,
    borderRadius: '4px',
    backgroundColor: checked ? '#000000' : '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    flexShrink: 0
  };

  const checkmarkStyle: CSSProperties = {
    color: '#ffffff',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '1'
  };

  return (
    <div
      style={checkboxContainerStyle}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onChange(!checked);
      }}
      role='checkbox'
      aria-checked={checked}
      tabIndex={disabled ? -1 : 0}
    >
      {checked && <span style={checkmarkStyle}>✓</span>}
    </div>
  );
};
